import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { DailyCardAdminItemDto, DailyCardOptionListResponseDto } from '@lunary/api-client'
import { api, ApiError } from '../../shared/api/client'
import type { CardText } from '../../shared/lib/card-text'

export const DAILY_CARDS_KEY = ['daily-cards']
export const DAILY_OPTIONS_KEY = ['daily-cards', 'options']

export function errorText(e: unknown): string {
  return e instanceof ApiError || e instanceof Error ? e.message : 'Что-то пошло не так'
}

export function useDailyOptions(enabled: boolean) {
  return useQuery({
    queryKey: DAILY_OPTIONS_KEY,
    queryFn: () => api.get<DailyCardOptionListResponseDto>('/admin/daily-cards/options'),
    enabled,
    staleTime: 60_000,
    retry: false,
  })
}

function useRefresh() {
  const qc = useQueryClient()
  return () => void qc.invalidateQueries({ queryKey: DAILY_CARDS_KEY, exact: true })
}

export function useDraw(date: string) {
  const refresh = useRefresh()
  return useMutation({
    mutationFn: () => api.post<DailyCardAdminItemDto>('/admin/daily-cards/draw', { date }),
    onSuccess: refresh,
  })
}

export function useChoose(date: string) {
  const refresh = useRefresh()
  return useMutation({
    mutationFn: (cardId: string) => api.put<DailyCardAdminItemDto>(`/admin/daily-cards/${date}/card`, { card_id: cardId }),
    onSuccess: refresh,
  })
}

function payload(text: CardText) {
  return { interpretation: text.body, headline: text.headline, attention: text.attention, advice: text.advice, question: text.question }
}

export function useSaveText(date: string) {
  const refresh = useRefresh()
  return useMutation({
    mutationFn: (text: CardText) => api.put<DailyCardAdminItemDto>(`/admin/daily-cards/${date}/interpretation`, payload(text)),
    onSuccess: refresh,
  })
}

export function usePublish(date: string) {
  const refresh = useRefresh()
  return useMutation({
    mutationFn: (text: CardText) => api.post<DailyCardAdminItemDto>(`/admin/daily-cards/${date}/publish`, payload(text)),
    onSuccess: refresh,
  })
}
